import { Link } from "react-router-dom";

interface Crumb {
  name: string;
  path?: string;
}

interface PageBannerProps {
  eyebrow?: string;
  title: string;
  description?: string;
  breadcrumbs: Crumb[];
}

export default function PageBanner({ eyebrow, title, description, breadcrumbs }: PageBannerProps) {
  return (
    <section className="relative mt-[68px] overflow-hidden border-b border-background-200 bg-background-100 px-4 pb-12 pt-12 md:px-8 md:pb-16 md:pt-16">
      <div className="paper-grid absolute inset-0 opacity-40" />
      <div className="relative mx-auto w-full max-w-8xl">
        <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
          {breadcrumbs.map((crumb, index) => (
            <span key={crumb.name} className="flex items-center gap-2">
              {index > 0 ? <i className="ri-arrow-right-s-line text-foreground-300" /> : null}
              {crumb.path ? (
                <Link to={crumb.path} className="transition-colors hover:text-primary-600">
                  {crumb.name}
                </Link>
              ) : (
                <span className="text-foreground-800">{crumb.name}</span>
              )}
            </span>
          ))}
        </nav>

        {eyebrow ? (
          <div className="mt-6 flex items-center gap-2 text-xs font-medium tracking-[0.28em] text-primary-600">
            <span className="h-px w-6 bg-primary-400" />
            {eyebrow}
          </div>
        ) : null}
        <h1 className="mt-3 font-heading text-3xl font-black leading-tight text-foreground-950 md:text-4xl">
          {title}
        </h1>
        {description ? (
          <p className="mt-4 max-w-3xl text-sm leading-relaxed text-foreground-600 md:text-base">
            {description}
          </p>
        ) : null}
      </div>
    </section>
  );
}